export default "__VITE_ASSET__DW5RWxq9__"